import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EditIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockPRs } from '../data/mockData';
import { PurchaseRequisition } from '../types';
export function PurchaseRequisitionList() {
  const navigate = useNavigate();
  const columns: Column<PurchaseRequisition>[] = [{
    key: 'prNo',
    label: 'PR No',
    render: pr => <span className="font-medium text-indigo-600" data-id="element-1709">{pr.prNo}</span>
  }, {
    key: 'departmentCode',
    label: 'Dept'
  }, {
    key: 'procurementMethod',
    label: 'Method'
  }, {
    key: 'estimatedDeliveryDate',
    label: 'Est. Delivery'
  }, {
    key: 'total',
    label: 'Total',
    render: pr => <span className="font-medium" data-id="element-1710">${pr.total.toLocaleString()}</span>
  }, {
    key: 'status',
    label: 'Status',
    render: pr => <StatusBadge status={pr.status} data-id="element-1711" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1712">
      <div className="flex items-center justify-between" data-id="element-1713">
        <div data-id="element-1714">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1715">
            Purchase Requisitions
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1716">
            Manage PRs and track their procurement lifecycle.
          </p>
        </div>
        <button onClick={() => navigate('/purchase-requisitions/create')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1717">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-1718" />
          New PR
        </button>
      </div>

      <div className="flex-1" data-id="element-1719">
        <DataTable columns={columns} data={mockPRs} keyExtractor={item => item.id} searchPlaceholder="Search PRs by number, department..." onRowClick={item => navigate(`/purchase-requisitions/${item.id}/edit`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-1721">
              <button onClick={() => navigate(`/purchase-requisitions/${item.id}/edit`)} className="text-indigo-600 hover:text-indigo-900" data-id="element-1722">
                <EditIcon className="h-4 w-4" data-id="element-1723" />
              </button>
            </div>} data-id="element-1720" />
      </div>
    </div>;
}